module.exports = __webpack_public_path__ + "static/img/undraw_svg_3.4ce6bb6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/undraw_svg_3.svg
// module id = iJi3
// module chunks = 0